import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import AppInput from "../../../_shared/components/FormItems/AppInput";
import AppButton from "../../../_shared/components/AppButton";
import CommandLine from "./CommandLine";
import { message } from "antd";
import { useStateValue } from "../../../_shared/context/AppStateStore";
import * as api from "../../../../api";

// ----------------------------------------------------------------------------

function AdminAuthPage(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [credentials, setCredentials] = useState({});
  const [, dispatch] = useStateValue();
  const history = useHistory();

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleChange(field) {
    return (e) => {
      setCredentials({ ...credentials, [field]: e.target.value });
    };
  }

  function handleSignIn(e) {
    e.preventDefault();
    api
      .signIn(credentials.email, credentials.password)
      .then((res) => {
        dispatch({
          type: "SIGN_IN_FULFILLED",
          payload: res,
        });
        history.push("/admin");
      })
      .catch((error) => {
        if (error && error.statusCode === 401) {
          message.error("Le credenziali non sono corrette.");
        } else {
          const defaultMessage =
            "Non è stato possibile completare il login. Riprovare più tardi.";

          const messageText = (error && error.serverMessage) || defaultMessage;

          message.error(messageText);
        }
      });
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <div className={props.className}>
      <div className="auth">
        <AppInput
          className="input"
          label="e-mail"
          value={credentials.email}
          onChange={handleChange("email")}
        />
        <AppInput
          className="input"
          label="Password"
          hiddenText
          value={credentials.password}
          onChange={handleChange("password")}
        />
        <AppButton
          uxType="primary"
          htmlType="button"
          className="submit-btn"
          onClick={handleSignIn}
        >
          Entra
        </AppButton>
      </div>
      <CommandLine />
    </div>
  );
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AdminAuthPage.propTypes = {
  className: PropTypes.string.isRequired,
};

AdminAuthPage.defaultProps = {};

// ----------------------------------------------------------------------------

const StyledAdminAuthPage = styled(AdminAuthPage)`
  & {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    .auth {
      .input {
        width: 300px;
        margin-bottom: 30px;
      }
      .submit-btn {
        width: 300px;
      }
    }
  }
`;
// ----------------------------------------------------------------------------

export default StyledAdminAuthPage;
